import { FormItem } from '../../../../../commons/Form/Form.types';
import { ProfileEntityFormSchema } from './ProfileEntityForm.types';

export const profileEntityData: FormItem<ProfileEntityFormSchema>[][] = [
  [
    {
      name: 'name',
      placeholder: 'Votre entreprise...',
      label: "Nom de l'entreprise",
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'address',
      placeholder: 'Votre adresse...',
      label: 'Adresse',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'city',
      placeholder: 'Votre ville...',
      label: 'Ville',
      type: 'text',
      required: true,
      disabled: false,
    },
    {
      name: 'postalCode',
      placeholder: 'Votre code postal...',
      label: 'Code postal',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'department',
      placeholder: 'Votre département...',
      label: 'Département',
      type: 'text',
      required: true,
      disabled: false,
    },
    {
      name: 'region',
      placeholder: 'Votre région...',
      label: 'Région',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'siret',
      placeholder: 'Numéro siret...',
      label: 'Siret',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'firstName_owner',
      placeholder: 'Prénom...',
      label: 'Prénom du représentant légal',
      type: 'text',
      required: true,
      disabled: false,
    },
    {
      name: 'lastName_owner',
      placeholder: 'Nom...',
      label: 'Nom du représentant légal',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'email_owner',
      placeholder: 'Email...',
      label: 'Email générique',
      type: 'text',
      required: true,
      disabled: false,
    },
    {
      name: 'phone_owner',
      placeholder: 'N° de téléphone...',
      label: 'N° de téléphone standard',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'function_owner',
      placeholder: 'Fonction...',
      label: 'Fonction du représentant légal',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
];

export const profileEntityDisabledData: FormItem<ProfileEntityFormSchema>[][] = [
  [
    {
      name: 'name',
      placeholder: 'Votre entreprise...',
      label: "Nom de l'entreprise",
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'address',
      placeholder: 'Votre adresse...',
      label: 'Adresse',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'city',
      placeholder: 'Votre ville...',
      label: 'Ville',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'postalCode',
      placeholder: 'Votre code postal...',
      label: 'Code postal',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'department',
      placeholder: 'Votre département...',
      label: 'Département',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'region',
      placeholder: 'Votre région...',
      label: 'Région',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'siret',
      placeholder: 'Numéro siret...',
      label: 'Siret',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'firstName_owner',
      placeholder: 'Prénom...',
      label: 'Prénom du représentant légal',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'lastName_owner',
      placeholder: 'Nom...',
      label: 'Nom du représentant légal',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'email_owner',
      placeholder: 'Email...',
      label: 'Email générique',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'phone_owner',
      placeholder: 'N° de téléphone...',
      label: 'N° de téléphone standard',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'function_owner',
      placeholder: 'Fonction...',
      label: 'Fonction du représentant légal',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
];
